<template>
  <div class="my-licence">
    <div class="account-card">
      <div class="account-card-header">
        <h4 class="account-card-title">处置预告管理</h4>
      </div>
      <div class="page-manage page-manage-evaluation-config">
        <customize-form
          :form-config="formConfig"
          @on-query="onQuery"
          @on-reset="onReset"
        ></customize-form>
        <customize-table
          :table-config="tableConfig"
          @size-change="onSizeChange"
          @current-change="onCurrentChange"
          :currentPage.sync="params.pageIndex"
          :key="keytable"
        >
          <template v-slot:title="{ column }">
            <el-table-column v-bind="column">
              <template v-slot="scope">
                <span class="cell-link" @click="onCheckBidFile(scope.row)">{{
                  scope.row.title
                }}</span>
              </template>
            </el-table-column>
          </template>
          <template v-slot:assetClass="{ column }">
            <el-table-column v-bind="column">
              <template v-slot="scope">
                <span>{{
                  scope.row.assetClass == 1
                    ? '废旧物资'
                    : scope.row.assetClass == 2
                    ? '闲置物资'
                    : ''
                }}</span>
              </template>
            </el-table-column>
          </template>
          <template v-slot:serveScope="{ column }">
            <el-table-column v-bind="column">
              <template v-slot="scope">
                <span>{{
                  scope.row.serveScope == 1
                    ? '竞价服务'
                    : scope.row.serveScope == 2
                    ? '全流程服务'
                    : ''
                }}</span>
              </template>
            </el-table-column>
          </template>
          <template v-slot:buyerCompName="{ column }">
            <el-table-column v-bind="column">
              <template v-slot="scope">
                <span class="cell-link" @click="onShowBuyer(scope.row)">{{
                  scope.row.buyerCompName
                }}</span>
              </template>
            </el-table-column>
          </template>
          <template v-slot:enroollAll="{ column }">
            <el-table-column v-bind="column">
              <template slot="header">
                竞买报名
                <el-tooltip
                  class="item"
                  effect="dark"
                  content="报名成功数/报名数"
                  placement="top"
                >
                  <i class="el-icon-question"></i>
                </el-tooltip>
              </template>
              <template slot-scope="scope">
                <span
                  v-if="scope.row.enrollExamine == 1"
                  @click="onAudit(scope.row)"
                  class="enroollAll"
                >
                  <span>{{ scope.row.enroollAudit }}</span
                  ><span>/</span><span>{{ scope.row.enroollAll }}</span>
                </span>
                <span v-else>
                  <span>{{ scope.row.enroollAudit }}</span
                  ><span>/</span><span>{{ scope.row.enroollAll }}</span></span
                >
              </template>
            </el-table-column>
          </template>
          <template v-slot:inspectAll="{ column }">
            <el-table-column v-bind="column">
              <template slot="header">
                申请看货
                <el-tooltip
                  class="item"
                  effect="dark"
                  content="已反馈购买商数/预约看货购买商数"
                  placement="top"
                >
                  <i class="el-icon-question"></i>
                </el-tooltip>
              </template>
              <template slot-scope="scope">
                <span v-if="scope.row.inspectWhether == 1">
                  <span class="enroollAll" @click="feedback(scope.row)">
                    <span>{{ scope.row.inspectAudit }}</span
                    ><span>/</span><span>{{ scope.row.inspectAll }} </span>
                  </span>
                </span>
              </template>
            </el-table-column>
          </template>

          <template v-slot:operateStatus="{ column }">
            <el-table-column v-bind="column">
              <template v-slot="scope">
                <span>{{ statusListfun(scope.row.operateStatus) }}</span>
              </template>
            </el-table-column>
          </template>
          <template v-slot:enroollAll1="{ column }">
            <el-table-column v-bind="column">
              <template v-slot="scope">
                <span
                  >{{ scope.row.enroollAudit }}/{{ scope.row.enroollAll }}</span
                >
              </template>
            </el-table-column>
          </template>
          <template v-slot:operationsbus="{ column }">
            <el-table-column v-bind="column">
              <template v-slot="scope">
                <el-button
                  type="text"
                  v-if="
                    scope.row.enrollExamine == 1 &&
                      (scope.row.operateStatus == 4 ||
                        scope.row.operateStatus == 22)
                  "
                  @click="onAudit(scope.row)"
                  :disabled="!scope.row.enroollTodo"
                  key="e"
                  >资格审核</el-button
                >
                <el-button
                  type="text"
                  v-if="
                    scope.row.inspectWhether == 1 &&
                      (scope.row.operateStatus == 4 ||
                        scope.row.operateStatus == 22)
                  "
                  @click="feedback(scope.row)"
                  :disabled="!scope.row.inspectTodo"
                  key="f"
                  >反馈</el-button
                >
                <el-button
                  type="text"
                  v-if="
                    Number(scope.row.operateStatus) < 22 &&
                      scope.row.operateStatus != 4
                  "
                  @click="onEdit(scope.row)"
                  >修改</el-button
                >
                <el-button
                  type="text"
                  v-if="scope.row.statusCode == 0"
                  @click="deleteAnnouncement(scope.row)"
                  >删除</el-button
                >
                <el-button
                  type="text"
                  v-if="scope.row.operateStatus == 1"
                  @click="undo(scope.row)"
                  >撤销</el-button
                >
                <el-button
                  type="text"
                  v-if="
                    scope.row.operateStatus == 4 ||
                      scope.row.operateStatus == 23 ||
                      scope.row.operateStatus == 22
                  "
                  @click="onClickPrepare(scope.row.id)"
                  >编制公告</el-button
                >
              </template>
            </el-table-column>
          </template>
        </customize-table>
      </div>
    </div>
  </div>
</template>
<script>
import { openNewPage, daterange } from '@/utils/constantime'

export default {
  components: {},

  data() {
    const statusList = [
      { value: null, label: '全部' },
      { value: 0, label: '未提交' },
      { value: 1, label: '待审批' },
      { value: 2, label: '审批中' },
      { value: 3, label: '待运营审核' },
      { value: 4, label: '报名中' },
      { value: 5, label: '审批不通过' },
      { value: 6, label: '运营审核不通过' },
      { value: 7, label: '撤回' },
      { value: 8, label: '发布后撤回' },
      { value: 9, label: '待确认' },
      { value: 10, label: '确认不通过' },
      { value: 22, label: '报名已结束' },
      { value: 23, label: '看货已结束' },
      { value: 24, label: '已编制公告' }
    ]
    return {
      viewFlag: false,
      clickRow: {},
      reconnaissanceFlag: false,
      keytable: Date.now(),
      dialogBuyer: false,
      dialogBuyerData: {},
      formtermination: {
        remark: ''
      },
      terminationsubmitid: '',
      dialogtermination: false,
      weightsubmitid: '',
      form: {
        remark: ''
      },
      dialogFormVisible: false,
      pageNum: 1,
      pageSize: 10,
      params: {
        pageIndex: 1,
        pageSize: 10
      },
      statusListVo: statusList,
      formConfig: {
        configs: {
          title: {
            tag: 'input',
            label: '预告标题'
          },
          code: {
            tag: 'input',
            label: '预告编号'
          },
          planCode: {
            tag: 'input',
            label: '委托编号'
          },
          compName: {
            tag: 'input',
            label: '委托企业'
          },
          status: {
            tag: 'select',
            label: '状态',
            default: null,
            options: statusList
          },
          enrollEndTime: {
            ...daterange,
            label: '报名截止时间'
          },
          inspectStartTime: {
            ...daterange,
            label: '看货开始日期'
          }
        },
        operations: [
          {
            label: '查询',
            handler: 'on-query',
            type: 'primary'
          },
          {
            label: '清空',
            handler: 'on-reset',
            type: 'default'
          }
        ]
      },

      removeV: 1,
      activeName: 1,
      // 默认表格配置
      tableConfig: {
        isPagination: true,
        columns: [
          {
            label: '序号',
            type: 'index',
            width: '50px',
            align: 'center',
            key: 20
          },
          {
            prop: 'code',
            label: '预告编号',
            width: '150px',
            'show-overflow-tooltip': true,
            key: 21
          },
          {
            slot: 'title',
            prop: 'title',
            label: '预告标题',
            width: '150px',
            'show-overflow-tooltip': true,
            key: 22
          },
          {
            prop: 'inspectStartTime',
            label: '看货开始时间',
            align: 'center',
            width: '150px',
            'show-overflow-tooltip': true,
            key: 26
          },
          {
            prop: 'enrollEndTime',
            label: '报名截止时间',
            align: 'center',
            width: '150px',
            'show-overflow-tooltip': true,
            key: 25
          },

          {
            prop: 'enroollAll',
            slot: 'enroollAll',
            label: '竞买报名',
            align: 'center',
            width: '100px',
            key: 27
          },
          {
            prop: 'inspectAll',
            slot: 'inspectAll',
            label: '申请看货',
            align: 'center',
            width: '100px',
            key: 29
          },
          {
            prop: 'planCode',
            label: '委托编号',
            width: '120px',
            'show-overflow-tooltip': true,
            key: 31
          },
          {
            prop: 'compName',
            label: '委托企业',
            width: '120px',
            'show-overflow-tooltip': true,
            key: 32
          },
          {
            slot: 'operateStatus',
            prop: 'operateStatus',
            label: '操作状态',
            align: 'center',
            width: '120px',
            key: 33
          },
          {
            slot: 'operationsbus',
            prop: 'operationsbus',
            label: '操作',
            width: '180px',
            align: 'center',
            fixed: 'right',
            key: 34
          }
        ],
        data: [],
        total: 0
      }
    }
  },
  watch: {},
  created() {
    this.listPrenotice()
  },
  methods: {
    onCheckBidFile(o) {
      let query = {
        id: o.id,
        type: 'check'
      }
      openNewPage('PrepareDetailCheck', query)
    },
    async onShowBuyer(o) {
      let data = await this.$api.enrooll.getEnroollByComp({
        noticeId: o.id,
        buyerCompCode: o.buyerCompCode
      })

      this.dialogBuyer = true
      this.dialogBuyerData = data
    },
    async listPrenotice() {
      let obj = {
        ...this.params
      }
      let data = await this.$api.serviceProvider.listPrenotice(obj)
      this.tableConfig.data = data.data
      this.tableConfig.total = data.total
    },
    remove(val) {
      this.removeV = val
    },
    onQuery(val) {
      let enrollEndTimeEnd = null
      let enrollEndTimeStart = null

      if (val.enrollEndTime) {
        enrollEndTimeEnd = val.enrollEndTime[1]
        enrollEndTimeStart = val.enrollEndTime[0]
      }

      this.params = {
        pageIndex: this.pageNum,
        pageSize: this.pageSize,
        enrollEndTimeEnd: enrollEndTimeEnd,
        enrollEndTimeStart: enrollEndTimeStart,
        ...val,
        inspectStartTimeEnd:
          val.inspectStartTime && val.inspectStartTime.length != 0
            ? val.inspectStartTime[1]
            : null,
        inspectStartTimeStart:
          val.inspectStartTime && val.inspectStartTime.length != 0
            ? val.inspectStartTime[0]
            : null,
        enrollEndTime: null,
        inspectStartTime: null
      }
      this.listPrenotice()
    },
    onReset() {
      this.params = {
        pageIndex: this.pageNum,
        pageSize: this.pageSize
      }
      this.listPrenotice()
    },
    onClickPrepare(id) {
      this.$router.push({
        name: 'ServiceCompileMaterialDetailUptata',
        query: { type: 'create', id: id, prepare: 1 }
      })
    },
    monitoring(o) {
      let query = {
        id: o.id
      }
      this.$router.push({ name: 'monitoring', query })
    },
    statusListfun(val) {
      let name
      if (val) {
        name = this.statusListVo.filter(item => item.value == val)[0].label
      } else {
        name = ''
      }
      return name
    },
    onEdit(o) {
      let query = {
        id: o.id,
        type: 'updata'
      }
      this.$router.push({ name: 'PrepareDetailUptata', query })
    },
    undo(o) {
      this.$confirm('确定撤销本条预告？', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        this.noticeBack(o)
      })
    },
    feedback(o) {
      let query = {
        id: o.id
      }
      this.$router.push({ name: 'ServiceForeteApplicationInspection', query })
    },
    onAudit(o) {
      let query = {
        id: o.id
      }
      this.$router.push({ name: 'ServiceForeteQualificationAudit', query })
    },
    onCurrentChange(val) {
      this.params = {
        ...this.params,
        pageIndex: val,
        pageSize: 10
      }
      this.listPrenotice()
    },
    onSizeChange(val) {
      this.params = {
        pageIndex: 1,
        pageSize: val
      }
      this.listPrenotice()
    },
    async noticeBack(o) {
      let data = await this.$api.serviceProvider.backPrenotice(o.id)
      if (data) {
        this.$message({
          type: 'success',
          message: '撤销成功!'
        })
      }
      this.listPrenotice()
    },

    //修改
    modify(o) {
      console.log(o)
      let query = {
        id: o.id,
        type: 'updata'
      }
      this.$router.push({ name: 'ServiceCompileMaterialDetailUptata', query })

      // openNewPage('CompileMaterialupdata', query)
    },
    async noticeDelete(o) {
      let obj = {
        id: o.id
      }
      let data = await this.$api.serviceProvider.deletePrenotice(obj)
      console.log(data)
      if (data) {
        this.$message({
          type: 'success',
          message: '删除成功!'
        })
      }
      this.listPrenotice()
    },
    //删除
    deleteAnnouncement(o) {
      this.$confirm('确定删除本条预告？', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      })
        .then(() => {
          this.noticeDelete(o)
        })
        .catch(() => {
          this.$message({
            type: 'info',
            message: '已取消删除'
          })
        })
    }
  }
}
</script>
<style lang="less" scoped>
.text {
  margin-right: 8px;
}
.enroollAll {
  color: red;
  cursor: pointer;
}
// span{
// pointer-events:none;
// color: lightslategrey;
// }
.distext {
  margin-right: 8px;
  pointer-events: none;
  color: lightslategrey;
}
.link {
  color: cornflowerblue;
  cursor: pointer;
}
p {
  margin-bottom: 10px;
}
.el-button--text {
  padding: 1px 5px;
}
</style>
